export default __webpack_public_path__ + "35442da9f7f6ab872aa59ab3686cbc87.png";